import React from "react";
import { FaHome } from "react-icons/fa";
import { LiaGoogleWallet} from "react-icons/lia";
import { GrTransaction } from "react-icons/gr";
import { Link } from "react-router-dom";

const Mobilenav = () => {
  return (
    <nav className="fixed bottom-[0px] left-0 right-0 px-6 py-6">
      <ul className="flex justify-around items-center py-6 px-4  shadow-md border-[1px] border-opacity-30 border-gray-200 rounded-[15px] bg-[radial-gradient(89.62%_213.03%_at_38.75%_80.3%,_#07031C_0%,_#241D4A_30.52%,_#07031C_64.32%)]">
        {/* Home */}
        <li>
          <Link
            to="/dashboard"
            className=" text-white hover:text-[#D4F5F9] grid place-items-center place-content-center gap-2"
          >
            <FaHome className="text-[25px] text-[#F2C493]" />
            <span className="text-xs text-[#D4F5F9]">Home</span>
          </Link>
        </li>
        {/* Invest */}
        <li>
          <Link
            to="/mobileinvestment"
            className="text-white hover:text-[#D4F5F9] grid place-items-center place-content-center gap-2"
          >
            <LiaGoogleWallet className="text-[25px] text-[#F2C493]" />
            <span className="text-xs text-[#D4F5F9]">Invest</span>
          </Link>
        </li>
        {/* Transaction */}
        <li>
          <Link
            to="/mobiletransaction"
            className="text-white hover:text-[#D4F5F9] grid place-items-center place-content-center gap-2"
          >
            <GrTransaction className="text-[25px] text-[#F2C493]" />
            <span className="text-xs text-[#D4F5F9]">Transaction</span>
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Mobilenav;
